const styles = () => ({
  grid: {
    marginTop: '56px',
  },
});

export default styles;
